import type { FC } from 'react';
import { Table } from 'reactstrap';
import { AccessModifierWrapper } from './AccessModifier.styled';

interface AccessModifierProps {}

const AccessModifier: FC<AccessModifierProps> = () => (
<AccessModifierWrapper>
   <header className="entry-header">
      <h1 className="entry-title" itemProp="headline">Access Modifier</h1>			
   </header>
   <div className="entry-content clear" itemProp="text">
      <p className="text-align-justify">To restrict the scope of a class, constructor, variable, method, or data member, we use access modifiers. There are mainly four types of access modifiers available :</p>
      <ul  className="text-align-justify">
         <li><strong>Default -</strong> It is set by default when no access modifier is specified. In other words, no one can access it from outside the package.</li>
         <li><strong>Public -</strong> It allows anyone to access the members of the class(on which access specifier is set) from anywhere.</li>
         <li><strong>Private -</strong> It limits its access within the class(on which access specifier is set). In other words, no one can access it from outside the class.</li>
         <li><strong>Protected -</strong> It limits its access within the class and from the class that inherits it. </li>
      </ul>

      <Table bordered striped responsive className="text-align-justify">
         <thead>
            <tr>
               <th>Access</th>
               <th>Same package (Non-derived)</th>
               <th>Same package (Derived)</th>
               <th>Other package (Non-derived)</th>
               <th>Other package (Derived)</th>
            </tr>
         </thead>
         <tbody>
            <tr>
               <th>Private</th>
               <td>No</td><td>No</td>
               <td>No</td><td>No</td>
            </tr>
            <tr>
               <th>Default</th>
               <td>Yes</td>
               <td>Yes</td>
               <td>No</td>
               <td>No</td>
            </tr>
            <tr>
               <th>Protected</th>
               <td>yes</td>
               <td>Yes</td>
               <td>No</td>
               <td>Yes</td>
            </tr>
            <tr>
               <th>Public</th>
               <td>Yes</td>
               <td>Yes</td>
               <td>Yes</td>
               <td>Yes</td>
            </tr>
         </tbody>
      </Table>
   </div>
</AccessModifierWrapper>
);

export default AccessModifier;
